// extracted by mini-css-extract-plugin
export default {"sidebar":"sidebar_sidebar__qYF9N","logo":"sidebar_logo__RMP0J","item":"sidebar_item__Glxnm","logout":"sidebar_logout__pkOCW"};